// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".phoneNumber[data-v-e7fe0aca] {\n  word-wrap: break-word;\n  word-break: break-all;\n  white-space: normal;\n  margin-right: 4px;\n}\n.pointer[data-v-e7fe0aca] {\n  color: #333;\n}\n.pointer[data-v-e7fe0aca]:hover {\n  color: #2c82ff;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
